export const monthValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;
export type MonthValue = typeof monthValues[number];

export function isMonthValue(value: unknown): value is MonthValue {
  return typeof value === "number" && monthValues.some((v) => v === value);
}
